import React, { useEffect, useState } from "react";
import arrowDown from "../../assets/icons/Group 356.svg";
import arrowUp from "../../assets/icons/uparrow.svg";


const PickUpTable = ({ data, room, filename, defaultSortColumn, label, isExpanded,
    onExpand, }) => {
    const [selectedRows, setSelectedRows] = useState([]);
    const [sortColumn, setSortColumn] = useState(null);
    const [sortDirection, setSortDirection] = useState("asc");
    const [currentPage, setCurrentPage] = useState(1);
    const [isCollapsed, setIsCollapsed] = useState(true);
    const rowsPerPage = 5; // Change this value as per your requirement
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    let currentRows = [];

    if (Array.isArray(data)) {
        const indexOfLastRow = currentPage * rowsPerPage;
        const indexOfFirstRow = indexOfLastRow - rowsPerPage;
        currentRows = data
        // .slice(indexOfFirstRow, indexOfLastRow);
    } else {
    }

    useEffect(() => {
        if (defaultSortColumn) {
            setSortColumn(defaultSortColumn);
        }
    }, [defaultSortColumn]);

    const sortedData = currentRows.slice().sort((a, b) => {
        if (sortColumn) {
            const valueA = a[sortColumn];
            const valueB = b[sortColumn];
            if (valueA < valueB) return sortDirection === "asc" ? 1 : -1;
            if (valueA > valueB) return sortDirection === "asc" ? -1 : 1;
        }
        return 0;
    });

    return (
        <div onClick={onExpand} className={`w-auto flex flex-col dark:bg-lightGradient bg-newGradient   text-white border rounded-lg cursor-pointer`}>
            <div className="w-[100%] flex p-2 justify-center items-center">
                <div className="w-[50%] flex flex-col justify-around">
                    <div className="pl-4">
                        <p className="text-[16px]">
                          {label}
                        </p>
                        <p className=" text-sm">
                            {data?.length} results found
                        </p>
                    </div>
                </div>
                <div className="w-[50%] flex justify-end pr-6">
                    <img src={isExpanded ? arrowUp : arrowDown} alt="" />
                </div>
            </div>
            {isExpanded && (
                <div className={` dark:bg-lightGradient bg-newGradient  text-white`}>
                    <div className="w-[100%] border-b-4 flex p-2 justify-center items-center">
                        <div className="w-[20%] text-center text-base font-medium flex items-center">
                            <p className="w-[55%]">{room ? "Rooms" : "Source"}</p>
                            {sortColumn === (room ? "rooms" : "source") && (
                                <img src={sortDirection === "asc" ? arrowUp : arrowDown} alt="Sort Indicator" className="w-4 h-4" />
                            )}
                        </div>
                        <div className="w-[20%] text-center text-base font-medium">
                            <p className="w-[70%]">Revenue</p>
                        </div>
                        <div className="w-[20%] text-center text-base font-medium">
                            <p className="w-[70%]">Room Nights</p>
                        </div>
                        <div className="w-[20%] text-center text-base font-medium">
                            <p className="w-[80%]">ADR</p>
                        </div>
                   
                    </div>
                    <div className="w-[100%] flex flex-col">
                        <div class="h-[250px] scroll-container">
                            {sortedData.map((item, index) => {
                                return (
                                    <div key={index}>
                                        <DataRow
                                            key={index}
                                            item={item}
                                            index={indexOfFirstRow + index}
                                            selectedRows={selectedRows}
                                            room={room}
                                        />
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PickUpTable;

const DataRow = ({
    data,
    room,
    item,
    index,
    selectedRows,
    setSelectedIndex,
    arrival=true,
    night,
    reservation
}) => {
    Array.prototype.random = function () {
        return this[Math.floor(Math.random() * this.length)];
    };
    const color = [
        "#1abc9c",
        "#f1c40f",
        "#2ecc71",
        "#2980b9",
        "#fad390",
        "#f8c291",
        "#60a3bc",
        "#4a69bd",
    ];

    const isSelected = selectedRows.includes(index);

    if (isSelected) {
    }

    return (
        <div className="flex flex-col py-2">
            <div
                className={`w-[100%] flex p-2 gap-2 justify-center items-center cursor-pointer`}

            >
             
                {arrival && <div className="w-[20%] text-center text-base font-medium flex items-center">
                    <p className="w-[55%]">{item.Source}</p>
                </div>}
                {arrival && <div className="w-[20%] text-center text-base font-medium flex items-center">
                    <p className={`w-[55%] ${item?.Revenue < 0 ? 'text-red-500' : ''}`}>
                        {item?.Revenue}
                    </p>
                </div>}
                {arrival && <div className="w-[20%] text-center text-base font-medium flex items-center">
                    <p className={`w-[55%] ${item["Room Nights"]? '' : ''}`}>
                        {item["Room Nights"]}
                    </p>
                </div>}
                {arrival && <div className="w-[20%] text-center text-base font-medium flex items-center">
                    <p className="w-[55%]">{item.ADR}</p>
                </div>}
             
            </div>
        </div>
    );
};
